import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { AgentOptionType, CollectSessionType, DeviceOptionType } from './types'

interface NewProps {
  collect_session: CollectSessionType
  agents?: AgentOptionType[]
  devices?: DeviceOptionType[]
}

export default function New({ collect_session, agents = [], devices = [] }: NewProps) {
  return (
    <>
      <Head title="Nouvelle session de collecte" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Nouvelle session de collecte</h1>

        <Form
          collect_session={collect_session}
          agents={agents}
          devices={devices}
          mode="new"
          method="post"
          action="/collect_sessions"
          submitText="Créer une session de collecte"
        />

        <Link
          href="/collect_sessions"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux sessions de collecte
        </Link>
      </div>
    </>
  )
}
